import { featureConfig } from '../constants/config/enum-config'

export enum Environments {
  local = 'local',
  qa = 'qa',
  prepro = 'prepro',
  prod = 'prod',
}

export enum SiteIds {
  BMAR = 'BMAR',
  ZJAR = 'ZJAR',
  BMCL = 'BMCL',
  BMEC = 'BMEC',
  BMMX = 'BMMX',
  BMPA = 'BMPA',
  BMPE = 'BMPE',
  BMVE = 'BMVE',
}

export const environments = Object.values(Environments)
export const siteIds = Object.values(SiteIds)

interface AvisoSelectedConfigDateItem {
  inicio: string
  fin: string
}
interface AvisoSelectedConfigBooleanItem {
  enabled: boolean
}
export type AvisosSelectedConfigItem = AvisoSelectedConfigDateItem | AvisoSelectedConfigBooleanItem
export type AvisosSelectedConfig = {
  [tipoAviso: string]: AvisosSelectedConfigItem
}
export interface SelectorEmpresa {
  idEmpresa: number
}

export interface ConfigParams {
  [featureConfig.RECOMENDADOS_BUMI]: boolean
  [featureConfig.DIRECCION_AUTOCOMPLETE]: boolean
  [featureConfig.SELECTA]: boolean
  [featureConfig.AVISO_NIVELES_LABORALES_RESTRINGIDOS]: { [key: string]: number[] }
  [featureConfig.AVISO_HUNTER]: boolean
  [featureConfig.AVISO_CONECTA_LIMITAR_AREA]: boolean
  [featureConfig.AVISO_HUNTER_EMPRESAS]: string[]
  [featureConfig.ESTADISTICAS_EMPRESAS]: boolean
  [featureConfig.ESTADISTICAS_COMPARATIVAS_EMPRESAS]: boolean
  [featureConfig.ESTADISTICAS_VISTAS_EMPRESAS]: boolean
  [featureConfig.JOBI]: boolean
  [featureConfig.JOBI_EMPRESAS]: string[]
  [featureConfig.HOME_HIDDEN_PRICES_PRODUCTS]: boolean
  [featureConfig.ENCABEZADO_AVISOS]: boolean
  [featureConfig.BENEFICIOS_AVISOS]: boolean
  [featureConfig.ENCABEZADO_PERFIL]: boolean
  [featureConfig.BENEFICIOS_PERFIL]: boolean
  [featureConfig.DASHBOARD_DEFAULT]: boolean
  [featureConfig.ECOMMERCE_DISABLED_ITEMS]: { name: string; productId: number }[]
  [featureConfig.BUSQUEDA_EN_BASE]: boolean
  [featureConfig.BANNER_GRATIS]: boolean
  [featureConfig.AVISO_TAG_NEW]: string[]
  [featureConfig.AVISO_CUPON]: boolean
  [featureConfig.AVISO_PALABRAS_RESTRINGIDAS]: string[]
  [featureConfig.PUBLICACION_SIN_REVISION_MANUAL]: boolean
  [featureConfig.MODAL_UPGRADE_EXPRESS]: boolean
  [featureConfig.AVISOS_CON_RECOMENDADOS]: AvisosSelectedConfig
  [featureConfig.AVISOS_CON_SUGERIDOS]: AvisosSelectedConfig
  [featureConfig.EMPRESAS_SOBRECARGADAS]: SelectorEmpresa[]
  [featureConfig.PANEL_EMPRESAS]: boolean
  [featureConfig.PANEL_EMPRESAS_CONSULTORAS]: boolean
  [featureConfig.NEW_SEARCH_BAR]: boolean
  [featureConfig.PROVINCIA_SAP_REGISTRO]: boolean
  [featureConfig.MENSAJES_EMPRESAS]: boolean
  [featureConfig.MENSAJES_EMPRESAS_LANDING]: boolean
  [featureConfig.MENSAJES_EMPRESAS_LANDING_FULLPAGE]: boolean
  [featureConfig.ENVIRONMENTS]: [string, string, ...string[]][]
  [featureConfig.PRODUCTOS_CARACTERISTICAS]: boolean
}

export type EnvsConfig = Partial<{
  [key in Environments]: Partial<ConfigParams>
}>

export type SiteIdsConfig = Partial<{
  [key in SiteIds]: Partial<ConfigParams>
}>

export type EnvsSiteIdsConfig = Partial<{
  [key in Environments]: SiteIdsConfig
}>

export type Config = ConfigParams & EnvsConfig & SiteIdsConfig & EnvsSiteIdsConfig
